import React from 'react';
import Navbar from '../Components/Navbar';
import PageHeader from '../Components/PageHeader';
import Footer from '../Components/Footer';

const About = () => {
  return (
    <div>
      <Navbar />
      <PageHeader 
        title="About Netbernet" 
        subtitle="Learn about our mission, vision, and the values that drive our company." 
      />
      
      {/* Mission & Vision */}
      <section className="py-16 px-6 bg-netbernet-white">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Mission */}
            <div className="bg-gray-50 p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl md:text-3xl font-bold text-netbernet-black mb-6">Our Mission</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Our belief in not just making an eye-catching design and valuable content, but to market and spread the brand and content to the web and internet community across the globe. We strive to deliver exceptional IT solutions that drive business growth and digital transformation.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                We are committed to providing our clients with innovative solutions that meet their unique needs and help them achieve their business objectives in the most efficient and effective manner.
              </p>
            </div>
            
            {/* Vision */}
            <div className="bg-netbernet-blue p-8 rounded-xl shadow-lg text-netbernet-white">
              <h2 className="text-2xl md:text-3xl font-bold mb-6">Our Vision</h2>
              <p className="text-lg leading-relaxed mb-6">
                We rely on expertise and techniques to make Netbernet your future partner, strong enough to challenge competitive IT services, online marketing, and stand by your side to generate valuable ideas and business solutions.
              </p>
              <p className="text-lg leading-relaxed">
                We envision becoming the leading IT solutions provider in the region, known for our innovation, reliability, and commitment to client success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 px-6 bg-gray-100">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Our Values</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The principles that guide everything we do at Netbernet
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { title: "Innovation", desc: "We embrace new technologies and creative solutions" },
              { title: "Excellence", desc: "We strive for quality in everything we deliver" },
              { title: "Integrity", desc: "We maintain honesty and transparency in all dealings" },
              { title: "Collaboration", desc: "We work closely with our clients as partners" }
            ].map((value, index) => (
              <div key={index} className="bg-netbernet-white p-6 rounded-xl shadow-md text-center">
                <h3 className="text-xl font-semibold mb-4 text-netbernet-black">{value.title}</h3>
                <p className="text-gray-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 px-6 bg-netbernet-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Our Team</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Meet the talented professionals behind Netbernet's success
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { name: "Mohammed Abdul Maqsood", role: "Founder & CEO", bio: "With over 15 years of experience in IT infrastructure and web services..." },
              { name: "Mohammed Ahmed", role: "Technical Director", bio: "Expert in cloud computing and network architecture with numerous certifications..." },
              { name: "Umar Mansuri", role: "Lead Developer", bio: "Full-stack developer specializing in modern web technologies and frameworks..." },
              { name: "Mohammed Jafer", role: "Digital Marketing Head", bio: "SEO and digital marketing expert with a proven track record of success..." },
              { name: "Mohammed Bilal", role: "UX/UI Designer", bio: "Creative designer focused on creating intuitive and beautiful user experiences..." },
              { name: "Hanan", role: "Client Relations", bio: "Dedicated to ensuring client satisfaction and building long-term relationships..." }
            ].map((member, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-xl text-center">
                <div className="w-24 h-24 bg-netbernet-blue rounded-full mx-auto mb-4 flex items-center justify-center text-netbernet-white text-2xl font-bold">
                  {member.name.split(' ').map(n => n[0]).join('')}
                </div>
                <h3 className="text-xl font-semibold mb-2">{member.name}</h3>
                <p className="text-netbernet-blue mb-4">{member.role}</p>
                <p className="text-gray-600">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* History */}
      <section className="py-16 px-6 bg-netbernet-blue text-netbernet-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Journey</h2>
            <p className="text-xl max-w-3xl mx-auto">
              From humble beginnings to becoming a leading IT solutions provider
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="relative">
              {/* Timeline */}
              {[
                { year: "2020", event: "Weblogix India founded in Hyderabad" },
                { year: "2021", event: "Expanded into web development services" },
                { year: "2022", event: "Launched cloud services division" },
                { year: "2023", event: "Reached 20+ clients milestone" },
                { year: "2024", event: "Rebranded to Netbernet to reflect our expanded vision and evolving digital capabilities" },
                { year: "2025", event: "Expanded service offerings to digital marketing" },
                { year: "2026", event: "50+ projects completed successfully" }
              ].map((milestone, index) => (
                <div key={index} className="flex items-start mb-8">
                  <div className="bg-netbernet-white text-netbernet-blue rounded-full w-12 h-12 flex items-center justify-center font-bold mr-6 mt-3 flex-shrink-0">
                    {milestone.year}
                  </div>
                  <div className="bg-netbernet-white bg-opacity-10 p-6 rounded-lg">
                    <p>{milestone.event}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;